import { Button, Dropdown } from "semantic-ui-react";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import Subscription from "~/models/Subscription/Subscription";

@observer
class InvoiceIndexHeader extends Component {
  render() {
    const { subscriptions, filterBySubscriptionId, subscriptionId, t } = this.props;

    const subscriptionOptions = [];

    subscriptions.forEach(subscription => {
      subscriptionOptions.push({
        key: subscription.subscriptionId,
        text: `${t("billingCentral:subscription")} #${subscription.subscriptionId}`,
        value: `${subscription.subscriptionId}`,
      });
    });

    return (
      <div className="side-page-index-header">
        <div className="side-page-index-header-tagline">
          <span>{t("billingCentral:searchBySubscription")}</span>
        </div>

        <div className="side-page-index-header-grid-wrap">
          <div className="side-page-index-header-controls dropdown-column">
            {subscriptions.length > 0 && (
              <Button.Group className="side-page-index-filter-by">
                <Dropdown
                  size="small"
                  icon="caret down"
                  className="button icon dropdown-filters"
                  floating
                  scrolling
                  options={subscriptionOptions}
                  onChange={(_e, selection) => filterBySubscriptionId(selection.value)}
                  value={subscriptionId}
                />
              </Button.Group>
            )}
          </div>

          <div className="side-page-index-header-h1">
            <h1>{t("billingCentral:invoices")}</h1>
          </div>
        </div>
      </div>
    );
  }
}

InvoiceIndexHeader.propTypes = {
  subscriptions: PropTypes.arrayOf(PropTypes.instanceOf(Subscription)),
  filterBySubscriptionId: PropTypes.func,
  subscriptionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  t: PropTypes.func.isRequired,
};

export default withTranslation()(InvoiceIndexHeader);
